export default __webpack_public_path__ + "static/carousell-sq-sell-car-icon-24hrs-bidding-9eeb22e9984ff40867fae974147ade6b.svg";